<section class="page-container">
  <div class="flex min-w-0 items-center justify-between gap-4">
    <h1 class="main-heading min-w-0">
      User Type Management - <span>{{ mode }}</span>
    </h1>
    <app-navpath class="hidden md:block"></app-navpath>
  </div>
  <div class="mb-2 flex w-full flex-col gap-2 md:w-fit md:flex-row">
    <button
      class="shorter-btn misc-btn"
      *ngIf="mode == 'Detail'"
      (click)="updateRole()"
      [disabled]="!isFormValid()"
    >
      <fa-icon [icon]="faPencil" class="mr-1"></fa-icon>Update User
      Type
    </button>
    <button
      class="shorter-btn misc-btn"
      *ngIf="mode == 'Add'"
      (click)="updateRole()"
      [disabled]="!isFormValid()"
    >
      <fa-icon [icon]="faPlus" class="mr-1"></fa-icon>Add User Type
    </button>
    <button
      class="shorter-btn clear-btn"
      [routerLink]="['/administration/user-type-management']"
    >
      <fa-icon [icon]="faBan" class="mr-1"></fa-icon>Cancel
    </button>
  </div>
  <div class="content-container">
    <section class="content-container">
      <app-data-form
        [dataFields]="formFields"
        [dataName]="'formFields'"
        (updateFields_child)="updateFields($event)"
      ></app-data-form>
    </section>
    <div class="my-4 flex w-full flex-col gap-2 md:w-fit md:flex-row">
      <button
        class="shorter-btn delete-btn"
        (click)="checkAndUncheckAll(true)"
      >
        <fa-icon [icon]="faSquareCheck" class="mr-1"></fa-icon>Check
        All
      </button>
      <button
        class="shorter-btn clear-btn"
        (click)="checkAndUncheckAll(false)"
      >
        <fa-icon [icon]="faSquare" class="mr-1"></fa-icon>Uncheck All
      </button>
    </div>
    <div class="content-container">
      <div class="w-full overflow-x-auto">
        <app-data-table
          class="block min-w-[56rem]"
          [tableHeaders]="tableHeaders"
          [tableEntries]="types_select"
          (checkChange)="checkPermission($event)"
        ></app-data-table>
      </div>
    </div>
  </div>
</section>
